import type { SVGProps } from 'react';
const SvgQuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-1.1 -1.1 24 24" {...props}>
    <desc>{'Question Circle Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M8.175 8.175a2.725 2.725 0 1 1 3.633 2.57 1.36 1.36 0 0 0-.908 1.285v.914"
    />
    <path stroke="currentColor" strokeWidth={2.2} d="M10.9 16.35a.34.34 0 0 1 0-.681M10.9 16.35a.34.34 0 0 0 0-.681" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={2.2}
      d="M10.9 21.119c5.644 0 10.219-4.575 10.219-10.219S16.544.681 10.9.681.681 5.256.681 10.9 5.256 21.119 10.9 21.119Z"
    />
  </svg>
);
export default SvgQuestionCircle;
